import { Injectable } from '@angular/core';
import { Http, Request, Response, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { InstitutionSetupModel } from '../models/InstitutionSetupModel';
import { HeaderFactory } from '../../common/HeaderFactory';

declare const OUTCOMES_API: string;

@Injectable()
export class ReadinessService {

    constructor(
        private http: Http, 
        private headerFactory: HeaderFactory
    ) {
        //
    }

    checkStatus(institutionId: number): Observable<InstitutionSetupModel> {
        const obseravable = this.http.get(OUTCOMES_API + '/validate-setup/' + institutionId, {
            headers: this.headerFactory.make()
        }).map(res => res.json());       

        return obseravable;
    }
}


/** WEBPACK FOOTER **
 ** ./app/readiness/services/ReadinessService.ts
 **/